const config = require('./stage.json');

export default config;
